import { render, staticRenderFns } from "./ContactRelbase.vue?vue&type=template&id=3d095380&scoped=true&"
import script from "./ContactRelbase.vue?vue&type=script&lang=js&"
export * from "./ContactRelbase.vue?vue&type=script&lang=js&"
import style0 from "./ContactRelbase.vue?vue&type=style&index=0&id=3d095380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d095380",
  null
  
)

export default component.exports